import Axios from 'axios'
import moment from 'moment'
import qs from "qs";

const AuthStatus = Object.freeze({NOT_AUTHORIZED: 0, AUTHORIZED: 1, AUTH_FAILED: 2, AUTH_EXPIRED: 3})
const AUTH_PRINCIPAL = "AUTH-PRINCIPAL";

function authInterceptor(token) {

    return Axios.interceptors.request.use(reqConfig => {
        reqConfig.headers.Authorization = `Bearer ${token}`;
        return reqConfig;
    });
}

function clearInterceptor(interceptor) {
    Axios.interceptors.request.eject(interceptor);
}

function loadState() {
    let savedPrincipal = localStorage.getItem(AUTH_PRINCIPAL);
    let finalState = resetState();
    if (savedPrincipal != undefined) {
        savedPrincipal = JSON.parse(savedPrincipal);
        const expiration = new Date(savedPrincipal.tokenExpiration);
        const expirationHours = moment(expiration).diff(new Date(), 'hours');
        if (expirationHours > 4) {
            finalState.principal = savedPrincipal;
            finalState.authStatus = AuthStatus.AUTHORIZED;
            finalState.authInterceptor = authInterceptor(finalState.principal.token);
        }
    }
    return finalState;
}

function clearPrincipal() {
    localStorage.removeItem(AUTH_PRINCIPAL);
}

function savePrincipal(state) {

    let toSave = JSON.stringify({...state.principal});
    localStorage.setItem(AUTH_PRINCIPAL, toSave);
}

function resetState() {
    return {
        authStatus: AuthStatus.NOT_AUTHORIZED,
        authInterceptor: null,
        principal: {
            username: "",
            role: "",
            token: "",
            tokenExpiration: null
        }
    }
}

const state = resetState();

const mutations = {
    RESET(state) {
        Object.assign(state, resetState());
    },
    SET_AUTH_INTERCEPTOR(state, authInterceptor) {
        state.authInterceptor = authInterceptor;
    },
    CLEAR_AUTH_INTERCEPTOR(state) {
        clearInterceptor(state.authInterceptor);
    },
    SET_AUTH_STATE(state, newAuthState) {
        state.authStatus = newAuthState;
    },
    SET_PRINCIPAL(state, {username, token, tokenExpiration, role}) {
        state.principal.username = username;
        state.principal.token = token;
        state.principal.tokenExpiration = tokenExpiration;
        state.principal.role = role;
    }
}

const actions = {
    async AUTHENTICATE({commit, dispatch}, {username, password}) {
        const kcEnabled = (await Axios.get("/auth/keycloak-enabled")).data;
        if (kcEnabled) {
            const loginParams = qs.stringify({
                grant_type: 'password',
                client_id: 'ot-backend',
                username: username,
                password: password,
            });
            return Axios.post(
                '/oauth2/realms/opentreasury/protocol/openid-connect/token',
                loginParams,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                },
            ).then(response => {
                    const token = response.data.access_token;
                    const tokenExpiration = new Date(
                        new Date().getTime() + response.data.expires_in * 1000,
                    ).toISOString();
                    const role = response.data.scope;
                    commit('SET_AUTH_INTERCEPTOR', authInterceptor(token));
                    commit('SET_AUTH_STATE', AuthStatus.AUTHORIZED);
                    commit('SET_PRINCIPAL', {username: username, token, tokenExpiration, role})
                    dispatch('SAVE_PRINCIPAL');
                    return response;
                },
                reason => {
                    commit('SET_AUTH_STATE', AuthStatus.AUTH_FAILED);
                    return reason;
                })
        } else {
            return Axios.post('/auth/authenticate', {user: username, password: password})
                .then(response => {
                        const token = response.data.token;
                        const tokenExpiration = response.data.tokenExpiration;
                        const role = response.data.role;
                        commit('SET_AUTH_INTERCEPTOR', authInterceptor(token));
                        commit('SET_AUTH_STATE', AuthStatus.AUTHORIZED);
                        commit('SET_PRINCIPAL', {username: username, token, tokenExpiration, role})
                        dispatch('SAVE_PRINCIPAL');
                        return response;
                    },
                    reason => {
                        commit('SET_AUTH_STATE', AuthStatus.AUTH_FAILED);
                        return reason;
                    })
        }
    },
    CLEAR_PRINCIPAL() {
        return Promise.resolve(clearPrincipal())
    },
    SAVE_PRINCIPAL({state}) {
        return Promise.resolve(savePrincipal(state));
    },
    RELOAD_STATE({state}) {
        let newState = loadState();
        Object.assign(state, newState);
    },
    LOGOUT({commit, dispatch}) {
        commit('SET_PRINCIPAL', {username: "", token: "", tokenExpiration: null})
        dispatch('CLEAR_PRINCIPAL');
        commit('SET_AUTH_STATE', AuthStatus.NOT_AUTHORIZED);
        commit('CLEAR_AUTH_INTERCEPTOR');
        location.reload();
    }
}

const getters = {
    actualPrincipal: (state) => {
        return state.principal;
    },
    actualStatus: (state) => {

        return state.authStatus
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
